"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeName = exports.paragraph = exports.heading = exports.fontFamily = exports.display = exports.defaultCssProps = exports.convertRemToPx = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var themeName = exports.themeName = {
  very: 'very',
  littlewoods: 'littlewoods'
};
var fontFamily = exports.fontFamily = _defineProperty(_defineProperty({}, themeName.very, "'Very Sans'"), themeName.littlewoods, "'Very Sans'");
var convertRemToPx = exports.convertRemToPx = function convertRemToPx(val) {
  var sanitisedVal = val.includes('rem') ? val.replace('rem', '') : val;
  return sanitisedVal * 16;
};
var defaultCssProps = exports.defaultCssProps = {
  m3: {
    fontSize: "".concat(10 / 16, "rem"),
    lineHeight: "".concat(14 / 16, "rem"),
    marginBottom: "var(--spacing-global-space3)"
  },
  m2: {
    fontSize: "".concat(12 / 16, "rem"),
    lineHeight: "".concat(16 / 16, "rem"),
    marginBottom: "var(--spacing-global-space3)"
  },
  m1: {
    fontSize: "".concat(14 / 16, "rem"),
    lineHeight: "".concat(20 / 16, "rem"),
    marginBottom: "var(--spacing-global-space3)"
  },
  t1: {
    fontSize: "".concat(16 / 16, "rem"),
    lineHeight: "".concat(24 / 16, "rem"),
    marginBottom: "var(--spacing-global-space4)"
  },
  t2: {
    fontSize: "".concat(18 / 16, "rem"),
    lineHeight: "".concat(26 / 16, "rem"),
    marginBottom: "var(--spacing-global-space4)"
  },
  t3: {
    fontSize: "".concat(22 / 16, "rem"),
    lineHeight: "".concat(32 / 16, "rem"),
    marginBottom: "var(--spacing-global-space5)"
  },
  t4: {
    fontSize: "".concat(25 / 16, "rem"),
    lineHeight: "".concat(36 / 16, "rem"),
    marginBottom: "var(--spacing-global-space5)"
  },
  t5: {
    fontSize: "".concat(30 / 16, "rem"),
    lineHeight: "".concat(40 / 16, "rem"),
    marginBottom: "var(--spacing-global-space6)"
  },
  t6: {
    fontSize: "".concat(34 / 16, "rem"),
    lineHeight: "".concat(48 / 16, "rem"),
    marginBottom: "var(--spacing-global-space6)"
  },
  t7: {
    fontSize: "".concat(40 / 16, "rem"),
    lineHeight: "".concat(52 / 16, "rem"),
    marginBottom: "var(--spacing-global-space7)"
  },
  t8: {
    fontSize: "".concat(45 / 16, "rem"),
    lineHeight: "".concat(56 / 16, "rem"),
    marginBottom: "var(--spacing-global-space7)"
  },
  t9: {
    fontSize: "".concat(52 / 16, "rem"),
    lineHeight: "".concat(64 / 16, "rem"),
    marginBottom: "var(--spacing-global-space8)"
  },
  t10: {
    fontSize: "".concat(60 / 16, "rem"),
    lineHeight: "".concat(80 / 16, "rem"),
    marginBottom: "var(--spacing-global-space8)"
  },
  t11: {
    fontSize: "".concat(70 / 16, "rem"),
    lineHeight: "".concat(88 / 16, "rem"),
    marginBottom: "var(--spacing-global-space9)"
  },
  t12: {
    fontSize: "".concat(82 / 16, "rem"),
    lineHeight: "".concat(104 / 16, "rem"),
    marginBottom: "calc(".concat(56 / 16, "rem * 1.6)") /* this is a custom value the designers specced */
  },
  t13: {
    fontSize: "".concat(95 / 16, "rem"),
    lineHeight: "".concat(120 / 16, "rem"),
    marginBottom: "var(--spacing-global-space10)"
  },
  t14: {
    fontSize: "".concat(110 / 16, "rem"),
    lineHeight: "".concat(144 / 16, "rem"),
    marginBottom: "calc(".concat(80 / 16, "rem * 1.6)") /* this is a custom value the designers specced */
  }
};
var cssProps = _defineProperty(_defineProperty({}, themeName.very, _objectSpread({}, defaultCssProps)), themeName.littlewoods, _objectSpread({}, defaultCssProps));
var display = exports.display = function display() {
  var _cssProps$theme, _cssProps$theme2, _cssProps$theme3, _cssProps$theme4, _cssProps$theme5, _cssProps$theme6, _cssProps$theme7, _cssProps$theme8, _cssProps$theme9, _cssProps$theme10, _cssProps$theme11, _cssProps$theme12, _cssProps$theme13, _cssProps$theme14;
  var themeBrand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : themeName.very;
  // Check that theme is a valid value, if not set it as very as default
  var theme = Object.keys(themeName).includes(themeBrand) ? themeBrand : themeName.very;
  return {
    display1: (_cssProps$theme = cssProps[theme]) === null || _cssProps$theme === void 0 ? void 0 : _cssProps$theme.t1,
    display2: (_cssProps$theme2 = cssProps[theme]) === null || _cssProps$theme2 === void 0 ? void 0 : _cssProps$theme2.t2,
    display3: (_cssProps$theme3 = cssProps[theme]) === null || _cssProps$theme3 === void 0 ? void 0 : _cssProps$theme3.t3,
    display4: (_cssProps$theme4 = cssProps[theme]) === null || _cssProps$theme4 === void 0 ? void 0 : _cssProps$theme4.t4,
    display5: (_cssProps$theme5 = cssProps[theme]) === null || _cssProps$theme5 === void 0 ? void 0 : _cssProps$theme5.t5,
    display6: (_cssProps$theme6 = cssProps[theme]) === null || _cssProps$theme6 === void 0 ? void 0 : _cssProps$theme6.t6,
    display7: (_cssProps$theme7 = cssProps[theme]) === null || _cssProps$theme7 === void 0 ? void 0 : _cssProps$theme7.t7,
    display8: (_cssProps$theme8 = cssProps[theme]) === null || _cssProps$theme8 === void 0 ? void 0 : _cssProps$theme8.t8,
    display9: (_cssProps$theme9 = cssProps[theme]) === null || _cssProps$theme9 === void 0 ? void 0 : _cssProps$theme9.t9,
    display10: (_cssProps$theme10 = cssProps[theme]) === null || _cssProps$theme10 === void 0 ? void 0 : _cssProps$theme10.t10,
    display11: (_cssProps$theme11 = cssProps[theme]) === null || _cssProps$theme11 === void 0 ? void 0 : _cssProps$theme11.t11,
    display12: (_cssProps$theme12 = cssProps[theme]) === null || _cssProps$theme12 === void 0 ? void 0 : _cssProps$theme12.t12,
    display13: (_cssProps$theme13 = cssProps[theme]) === null || _cssProps$theme13 === void 0 ? void 0 : _cssProps$theme13.t13,
    display14: (_cssProps$theme14 = cssProps[theme]) === null || _cssProps$theme14 === void 0 ? void 0 : _cssProps$theme14.t14,
    fontColor: 'var(--color-global-black)',
    fontWeight: '800' // referenced as 400 in Figma
  };
};
var heading = exports.heading = function heading() {
  var _cssProps$theme15, _cssProps$theme16, _cssProps$theme17, _cssProps$theme18, _cssProps$theme19, _cssProps$theme20, _cssProps$theme21, _cssProps$theme22, _cssProps$theme23, _cssProps$theme24, _cssProps$theme25, _cssProps$theme26, _cssProps$theme27, _cssProps$theme28, _cssProps$theme29, _cssProps$theme30, _cssProps$theme31;
  var themeBrand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : themeName.very;
  // Check that theme is a valid value, if not set it as very as default
  var theme = Object.keys(themeName).includes(themeBrand) ? themeBrand : themeName.very;
  return {
    headingM3: (_cssProps$theme15 = cssProps[theme]) === null || _cssProps$theme15 === void 0 ? void 0 : _cssProps$theme15.m3,
    headingM2: (_cssProps$theme16 = cssProps[theme]) === null || _cssProps$theme16 === void 0 ? void 0 : _cssProps$theme16.m2,
    headingM1: (_cssProps$theme17 = cssProps[theme]) === null || _cssProps$theme17 === void 0 ? void 0 : _cssProps$theme17.m1,
    heading1: (_cssProps$theme18 = cssProps[theme]) === null || _cssProps$theme18 === void 0 ? void 0 : _cssProps$theme18.t1,
    heading2: (_cssProps$theme19 = cssProps[theme]) === null || _cssProps$theme19 === void 0 ? void 0 : _cssProps$theme19.t2,
    heading3: (_cssProps$theme20 = cssProps[theme]) === null || _cssProps$theme20 === void 0 ? void 0 : _cssProps$theme20.t3,
    heading4: (_cssProps$theme21 = cssProps[theme]) === null || _cssProps$theme21 === void 0 ? void 0 : _cssProps$theme21.t4,
    heading5: (_cssProps$theme22 = cssProps[theme]) === null || _cssProps$theme22 === void 0 ? void 0 : _cssProps$theme22.t5,
    heading6: (_cssProps$theme23 = cssProps[theme]) === null || _cssProps$theme23 === void 0 ? void 0 : _cssProps$theme23.t6,
    heading7: (_cssProps$theme24 = cssProps[theme]) === null || _cssProps$theme24 === void 0 ? void 0 : _cssProps$theme24.t7,
    heading8: (_cssProps$theme25 = cssProps[theme]) === null || _cssProps$theme25 === void 0 ? void 0 : _cssProps$theme25.t8,
    heading9: (_cssProps$theme26 = cssProps[theme]) === null || _cssProps$theme26 === void 0 ? void 0 : _cssProps$theme26.t9,
    heading10: (_cssProps$theme27 = cssProps[theme]) === null || _cssProps$theme27 === void 0 ? void 0 : _cssProps$theme27.t10,
    heading11: (_cssProps$theme28 = cssProps[theme]) === null || _cssProps$theme28 === void 0 ? void 0 : _cssProps$theme28.t11,
    heading12: (_cssProps$theme29 = cssProps[theme]) === null || _cssProps$theme29 === void 0 ? void 0 : _cssProps$theme29.t12,
    heading13: (_cssProps$theme30 = cssProps[theme]) === null || _cssProps$theme30 === void 0 ? void 0 : _cssProps$theme30.t13,
    heading14: (_cssProps$theme31 = cssProps[theme]) === null || _cssProps$theme31 === void 0 ? void 0 : _cssProps$theme31.t14,
    fontColor: 'var(--color-global-black)',
    fontWeight: '700'
  };
};
var paragraph = exports.paragraph = function paragraph() {
  var _cssProps$theme32, _cssProps$theme33, _cssProps$theme34, _cssProps$theme35, _cssProps$theme36, _cssProps$theme37, _cssProps$theme38, _cssProps$theme39, _cssProps$theme40, _cssProps$theme41, _cssProps$theme42, _cssProps$theme43, _cssProps$theme44, _cssProps$theme45, _cssProps$theme46, _cssProps$theme47, _cssProps$theme48;
  var themeBrand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : themeName.very;
  // Check that theme is a valid value, if not set it as very as default
  var theme = Object.keys(themeName).includes(themeBrand) ? themeBrand : themeName.very;
  return {
    paragraphM3: (_cssProps$theme32 = cssProps[theme]) === null || _cssProps$theme32 === void 0 ? void 0 : _cssProps$theme32.m3,
    paragraphM2: (_cssProps$theme33 = cssProps[theme]) === null || _cssProps$theme33 === void 0 ? void 0 : _cssProps$theme33.m2,
    paragraphM1: (_cssProps$theme34 = cssProps[theme]) === null || _cssProps$theme34 === void 0 ? void 0 : _cssProps$theme34.m1,
    paragraph1: (_cssProps$theme35 = cssProps[theme]) === null || _cssProps$theme35 === void 0 ? void 0 : _cssProps$theme35.t1,
    paragraph2: (_cssProps$theme36 = cssProps[theme]) === null || _cssProps$theme36 === void 0 ? void 0 : _cssProps$theme36.t2,
    paragraph3: (_cssProps$theme37 = cssProps[theme]) === null || _cssProps$theme37 === void 0 ? void 0 : _cssProps$theme37.t3,
    paragraph4: (_cssProps$theme38 = cssProps[theme]) === null || _cssProps$theme38 === void 0 ? void 0 : _cssProps$theme38.t4,
    paragraph5: (_cssProps$theme39 = cssProps[theme]) === null || _cssProps$theme39 === void 0 ? void 0 : _cssProps$theme39.t5,
    paragraph6: (_cssProps$theme40 = cssProps[theme]) === null || _cssProps$theme40 === void 0 ? void 0 : _cssProps$theme40.t6,
    paragraph7: (_cssProps$theme41 = cssProps[theme]) === null || _cssProps$theme41 === void 0 ? void 0 : _cssProps$theme41.t7,
    paragraph8: (_cssProps$theme42 = cssProps[theme]) === null || _cssProps$theme42 === void 0 ? void 0 : _cssProps$theme42.t8,
    paragraph9: (_cssProps$theme43 = cssProps[theme]) === null || _cssProps$theme43 === void 0 ? void 0 : _cssProps$theme43.t9,
    paragraph10: (_cssProps$theme44 = cssProps[theme]) === null || _cssProps$theme44 === void 0 ? void 0 : _cssProps$theme44.t10,
    paragraph11: (_cssProps$theme45 = cssProps[theme]) === null || _cssProps$theme45 === void 0 ? void 0 : _cssProps$theme45.t11,
    paragraph12: (_cssProps$theme46 = cssProps[theme]) === null || _cssProps$theme46 === void 0 ? void 0 : _cssProps$theme46.t12,
    paragraph13: (_cssProps$theme47 = cssProps[theme]) === null || _cssProps$theme47 === void 0 ? void 0 : _cssProps$theme47.t13,
    paragraph14: (_cssProps$theme48 = cssProps[theme]) === null || _cssProps$theme48 === void 0 ? void 0 : _cssProps$theme48.t14,
    fontColor: 'var(--color-global-grey900)',
    fontWeight: '400' // referenced as 500 in Figma
  };
};